<template>
  <li
    v-if="isExpand"
    class="rt-timeline-item el-timeline-item"
  >
    <!-- 圆点连接线 -->
    <div class="rt-timeline-item__tail"></div>

    <!-- 时间戳圆点 -->
    <div
      :class="[`rt-timeline-item__circle--${iconColor || ''}`]"
      class="el-timeline-item__node el-timeline-item__node--normal"
    ></div>

    <!-- 时间戳与内容 -->
    <div class="rt-timeline-item__wrapper">
      <div
        :class="[`rt-timeline-item__timestamp--${timeColor || ''}`]"
        class="rt-timeline-item__timestamp"
      >
        {{ dateFormat() || timestamp }}
      </div>

      <div class="rt-timeline-item__content">
        <slot></slot>
      </div>
    </div>
  </li>
</template>

<script>
import moment from 'moment';
// // 定义时间戳圆点颜色
// const iconColor = ['primary', 'success', 'warning', 'danger', 'info'];

// // 定义时间戳颜色
// const timeColor = ['primary', 'regular', 'secondary', 'placeholder'];

export default {
  name: 'RtTimelineItem',

  inject: ['timeline'],

  props: {
    timestamp: String,
    format: String,

    placement: {
      type: String,
      default: 'top'
    },
    iconColor: {
      type: String,
      default: 'primary'
    },
    timeColor: {
      type: String,
      default: 'primary'
    },
    icon: String
  },
  data () {
    return {
      isExpand: true
    };
  },
  beforeCreate () {
    this.$parent.steps.push(this);
  },
  beforeDestroy () {
    const steps = this.$parent.steps;
    const index = steps.indexOf(this);
    if (index >= 0) {
      steps.splice(index, 1);
    }
  },
  methods: {
    dateFormat () {
      if (!this.timestamp) {
        return '';
      }

      return moment(this.timestamp).format(this.format);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTimelineItem.vue?876df3e0